<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        :title="title"
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        :parent-component="$options.name"
        @alternate_action="onAlternateAction($event)"
        :qrcode="qrcode"
        :row-background="defaultRowBackGround"
        detailComponentPass="/CoreMaterial/MaterialReservation/MaterialReservationDetail"
    >
      <template v-slot:bar>
        <slot name="bar"></slot>
      </template>
      <template v-slot:top>
        <slot name="top"></slot>
      </template>
      <template v-slot:top.bar.filter>
        <slot name="top.bar.filter"></slot>
      </template>
      <template v-slot:item.material__supply_type="{ item }">
        <span v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid]">
          <ChoiceSupplyType
              :item="storeAggregate.rootData[item.material_uid]"
              :small="true"
              :readonly="true"
              @click="detailStoreMaterial.openDetailDialog({item: null, uid: item.material_uid})"
          >
<!--          {{storeAggregate.rootData[item.material_uid].supply_type}}-->
          </ChoiceSupplyType>
        </span>
      </template>
      <template v-slot:item.material__location__name="{ item }">
        <span
            v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid] && !!storeAggregate.rootData[item.material_uid].location_uid">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.material_uid].location_uid].name }}
        </span>
      </template>
      <template v-slot:item.batchrun_component__batch_run__name="{ item }">
        <span v-if="!!item.batchrun_component_uid && !!storeAggregate.rootData[item.batchrun_component_uid] &&
        !!storeAggregate.rootData[item.batchrun_component_uid].batch_run_uid && !!storeAggregate.rootData[storeAggregate.rootData[item.batchrun_component_uid].batch_run_uid]">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.batchrun_component_uid].batch_run_uid].name }}
        </span>
      </template>
      <template v-slot:item.material__location__fullname="{ item }">
        <span v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid] &&
        !!storeAggregate.rootData[item.material_uid].location_uid">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.material_uid].location_uid].fullname }}
        </span>
      </template>
      <template v-slot:item.material__lifecycle="{ item }">
        <span v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid]">
          <MaterialLifecycleSelect :value="storeAggregate.rootData[item.material_uid].lifecycle"></MaterialLifecycleSelect>
        </span>
      </template>
      <template v-slot:item.material__component__article="{ item }">
        <span v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid] &&
        !!storeAggregate.rootData[item.material_uid].component_uid">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.material_uid].component_uid].article_display }}
        </span>
      </template>
      <template v-slot:item.material__current_qty="{ item }">
        <span v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid]">
          {{ storeAggregate.rootData[item.material_uid].current_qty }}
        </span>
      </template>
      <template v-slot:item.material__batch_start_qty="{ item }">
        <span v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid]">
          {{ storeAggregate.rootData[item.material_uid].batch_start_qty }}
        </span>
      </template>
      <template v-slot:item.material__min_remaining_qty="{ item }">
        <span v-if="!!item.material_uid && !!storeAggregate.rootData[item.material_uid]">
          {{ storeAggregate.rootData[item.material_uid].min_remaining_qty }}
        </span>
      </template>
      <!--      <template v-slot:footer.prepend>-->
      <!--        <slot name="footer.prepend"></slot>-->
      <!--        <slot name="footer.middle">{{''}}</slot>-->
      <!--        <slot name="footer.page-text">{{''}}</slot>-->
      <!--      </template>-->
    </CommonTable>
    <v-dialog
        v-if="!!detailStoreMaterial"
        v-model="detailStoreMaterial.dialogDetail"
        persistent
        scrollable
    >
      <MaterialDetail
          :uid-item="detailStoreMaterial.uidItem"
          :store-name="detailStoreMaterialName"
          :modalDialog="true"
          :route-full-screen="{name: 'MaterialDetail', params: {itemUid: detailStoreMaterial.uidItem}}"
          :main-validator="true"
          :embedded="embedded"
      ></MaterialDetail>
    </v-dialog>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import {v4 as uuidv4} from "uuid";
import ChoiceSupplyType from "@/components/CoreComponent/ProductOrder/ChoiceSupplyType";
import {useDetailStore} from "@/components/Common/CommonDetail";
import MaterialLifecycleSelect from "@/components/CoreMaterial/Material/MaterialLifecycleSelect.vue";
import {defineAsyncComponent} from "vue";

export default {
  name: "MaterialReservationTable",

  props: {
    embedded: {default: false},
    title: {default: 'Material reservation'},
    headers: {default: null},
    qrcode: {default: null},
    height: {default: null},
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoDetailQuery: {default: 'MaterialReservationDetailQueryDTO'},
    detailStoreName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoListQuery: {type: [String], default: 'MaterialReservationListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialReservationActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
    selectedBatchRunUid: {default: null},
  },

  components: {
    MaterialLifecycleSelect,
    CommonTable,
    ChoiceSupplyType,
    MaterialDetail: defineAsyncComponent(() =>
      import("@/components/CoreMaterial/Material/MaterialDetail.vue")
    ),
  },

  methods: {
    onAlternateAction(event) {
      console.log('onAlternateAction', event)
      if (event.actionName === 'alternate_print_batchrun_label')
        this.storeTable.onAction({
          actionName: 'print_batchrun_label',
          actionUid: event.actionUid,
          data: {batchrun_uid: this.selectedBatchRunUid}
        })
      if (event.actionName === 'alternate_batch_start')
        this.storeTable.onAction({
          actionName: 'batch_start',
          actionUid: event.actionUid,
          data: {batchrun_uid: this.selectedBatchRunUid}
        })
    },

    defaultRowBackGround(item) {
      // console.log('this.rowStatuses', this.rowStatuses)
      if (!!item.material_uid && !!this.storeAggregate.rootData[item.material_uid]) {
        if (!this.storeAggregate.rootData[item.material_uid].location_uid)
          return 'red lighten-4'
      }
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = this.headers || [
      // {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Material', value: 'material__supply_type', sortable: true, filterable: true, divider: true},
      {text: 'Location', value: 'material__location__name', sortable: true, filterable: true, divider: true, width: 200},
      {text: 'Full location', value: 'material__location__fullname', sortable: false, filterable: true, divider: true, width: 200},
      {text: 'Article', value: 'material__component__article', sortable: true, filterable: true, divider: true},
      {text: 'Material UID', value: 'material_uid', sortable: true, filterable: true, divider: true},
      {text: 'Reservation quantity', value: 'quantity', sortable: true, true: true, divider: true},
      {text: 'Current QTY', value: 'material__current_qty', sortable: true, true: true, divider: true},
      {text: 'Batch start QTY', value: 'material__batch_start_qty', sortable: false, true: true, divider: true},
      {text: 'Min remaining QTY', value: 'material__min_remaining_qty', sortable: false, true: true, divider: true},
      {text: 'QTY delta', value: 'qty_delta', sortable: true, true: true, divider: true},

      {text: 'Lifecycle', value: 'material__lifecycle', sortable: true, filterable: true, divider: true, width: 200},

      {text: 'BatchRun', value: 'batchrun_component__batch_run__name', sortable: true, true: true, divider: true},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      // {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      // this.storeTable.options.sortBy = ['material__name']
      this.storeTable.options.sortDesc = [true]
      this.storeTable.options.multiSort = false
      this.storeTable.options.itemsPerPage = -1
    }
    this.detailStoreMaterial = useDetailStore(this.detailStoreMaterialName)()
  },

  data() {
    return {
      storeTable: null,

      detailStoreMaterial: null,
      detailStoreMaterialName: uuidv4(),
    }
  },
}
</script>

<style scoped>

</style>